/**
 * Utilitaires pour les dates
 * Fonctions pures <20 lignes chacune
 */

export function parseDate(dateString) {
  if (!dateString) return null
  try {
    const parts = dateString.trim().split('/')
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10)
      const month = parseInt(parts[1], 10) - 1
      const year = parseInt(parts[2], 10)
      
      if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
        return new Date(year, month, day)
      }
    }
    const date = new Date(dateString)
    return isNaN(date.getTime()) ? null : date
  } catch {
    return null
  }
}

export function isFuture(dateString) {
  if (!dateString) return false
  const date = parseDate(dateString)
  if (!date) return false
  date.setHours(0, 0, 0, 0)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return date > today
}

// Formatage de dates déplacé vers dateFormatters.js

export function isOverdue(dateString) {
  if (!dateString) return false
  const date = parseDate(dateString)
  if (!date) return false
  date.setHours(0, 0, 0, 0)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return date < today
}

// Formatage de dates déplacé vers dateFormatters.js

